import { useEpisodes } from "../../../../../Recoil/Novel/Episode";
import { fn, isAgeAdult } from "../../../../../Functions";
import { useEffect, useState } from "react";
import { useReaderSetting } from "../../../../../Recoil/Novel/ReaderSetting";
import { Button, IconButton, Slider } from "@mui/material";
import { useTitles } from "../../../../../Recoil/Novel/Title";
import { useReaderSize } from "../../../../../Recoil/Novel/ReaderSize";
import { logBehavior } from "../../../../../Data/Behavior";
import { useToastAlert } from "design-system/Toast";
import { useUsers } from "../../../../../Recoil/User/User";
import { useSession } from "../../../../../Recoil/Session/Session";
import AgeVerificationDialog from "../../../../../Components/AgeVerificationDialog";

const sizeLabel = { "80%": "작게", "100%": "기본", "120%": "크게" };

const UIGroup = ({
    serviceId, titleId, episodeId,
    isBarVisible, onClose,
}: {
    serviceId: string, titleId: string, episodeId: string,
    isBarVisible: boolean, onClose: () => void,
}) => {
    const { titleObject } = useTitles();
    const { episodeObject } = useEpisodes();
    const { setting, setType, setTheme, setFontSize } =  useReaderSetting();
    const {toastAlert} = useToastAlert();
    const {userObject} = useUsers();
    const {session} = useSession();
    
    const [showAgeVerification, setShowAgeVerification] = useState(false);

    const {page, setPage} = useReaderSize();
    const [isSettingVisible, setIsSettingVisible] = useState(false);
    const [current, setCurrent] = useState(page.current);
    useEffect(()=>{
        setCurrent(page.current);
    },[page])

    useEffect(()=> {
        setIsSettingVisible(false);
    }, [isBarVisible]);
    
    useEffect(() => {
        let updateHandler: ReturnType<typeof setTimeout> | undefined = undefined;
        const paginationContorl = () => {
            clearTimeout(updateHandler);
            updateHandler = setTimeout(() => {
                const scrollY = window.scrollY;
                if (scrollY <= page.readerYRange[0] ) {
                    setPage((page) => ({...page, current: 1}));
                    return;
                } else if (scrollY > page.readerYRange[1]){
                    setPage((page) => ({...page, current: page.total}));
                    return;
                }

                const current = Math.round((scrollY - page.readerYRange[0]) / window.innerHeight) + 1;
                setPage((page) => ({...page, current}));
            }, 50);
        };

        window.addEventListener('scroll', paginationContorl);

        return () => {
            window.removeEventListener('scroll', paginationContorl);
            clearTimeout(updateHandler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    const title = titleObject[`${serviceId}:${titleId}`];
    const currentIdx = episodeObject[`${serviceId}:${titleId}`]?.findIndex( episode => episode.episodeId === episodeId );
    const episode = episodeObject[`${serviceId}:${titleId}`]?.[currentIdx];
    const nextEpisode = episodeObject[`${serviceId}:${titleId}`]?.[currentIdx + 1];
    const prevEpisode = episodeObject[`${serviceId}:${titleId}`]?.[currentIdx - 1];

    // Check if age verification is needed
    const needsAgeVerification = (episode: EpisodeType): boolean => {
        if (!title?.isAdult || !episode || episode.isFree) {
            return false;
        }       

        return !isAgeAdult(new Date(userObject[session?.addressid ?? ""]?.certificatedBirthday ?? new Date()));
    };
    
    return <div className={"UIGroup"} onClick={(e)=> {
            onClose();
            e.stopPropagation();
        }}>
        <div className={`TopBar ${isBarVisible ? "Visible" : "Invisible"}`}
            onClick={(e) => { e.stopPropagation(); }}
        >
            <IconButton
                href={`/contents/${serviceId}/${titleId}`}
                onClick={fn.gotoByAnchor}
            >
                <img 
                    src="https://static.webtoon.today/ddah/icon/chevron_left_thick.svg" 
                    alt='arrow' width={24} height={24}
                />
            </IconButton>
            <div className={"TopBarTitle"} >{episode?.title ?? ""}</div>
        </div>
        <div className={`BottomBar ${isBarVisible ? "Visible" : "Invisible"}`}
            onClick={(e) => {e.stopPropagation();}}
        >
            <div className={"ProgressBar"} >
                <Slider
                    value={current} min={1} max={page.total ?? 1}
                    onChange={(_, value) => {
                        if (Array.isArray(value)) return;
                        setCurrent(value);
                    }} onChangeCommitted={()=>{
                        window.scrollTo({left: 0, top: page.readerYRange[0] + (current - 1) * window.innerHeight, behavior: 'smooth'});
                    }}
                    step={1}
                    marks={true}
                    slotProps={{thumb: {style: {backgroundColor: 'white'}}}}
                />
                <div className={"PaginationCountBox"}>
                    <div className={"CurrentPage"}>{current}</div>
                    <div className={"Divider"}>/</div>
                    <div className={"TotalPage"}>{page.total}</div>
                </div>
            </div>
            <div className={"NavBox"} >
                <Button className={"DisplaySetting"} onClick={() => { setIsSettingVisible(true);}} >
                    <img src="https://static.novela.today/icon/text_viewer_setting.png" alt='arrow' width={20} height={20} />
                    {"보기설정"}
                </Button>
                <div className={"OtherEpisodes"}>
                    {prevEpisode &&
                    <Button className={"PreviousEpisode"} onClick={fn.gotoByAnchor} href={`/contents/${serviceId}/${titleId}/${prevEpisode.episodeId}`} >
                        <img src="https://static.webtoon.today/ddah/icon/chevron_left_thick.svg" alt='arrow' width={20} height={20} />
                        {"이전화"}
                    </Button>}
                    {nextEpisode &&
                    <Button className={"NextEpisode"} onClick={(e) =>{
                        logBehavior("clickNextEpisode", {serviceId, titleId, episodeId: nextEpisode.episodeId, pixel: "Lead"});
                        if (needsAgeVerification(nextEpisode)) {
                            e.preventDefault();
                            logBehavior('click-payment-endof-free-ep-ui', {serviceId, titleId});
                            setShowAgeVerification(true);
                            return;
                        } else if (!nextEpisode.isFree && title.timeRemain === 0) {
                            e.preventDefault();
                            logBehavior('click-payment-endof-free-ep-ui', {serviceId, titleId});
                            toastAlert("해당 회차는 열람권 구매가 필요합니다.", 3000, "info");
                            fn.goto(`/payment/${serviceId}/${titleId}`);
                            return;
                        }
                        fn.gotoByAnchor(e);
                    }} href={`/contents/${serviceId}/${titleId}/${nextEpisode.episodeId}`} >
                        {"다음화"}
                        <img src="https://static.webtoon.today/ddah/icon/chevron_right_thick.svg" alt='arrow' width={20} height={20} />
                    </Button>}
                </div>
            </div>
        </div>
        
        <div className={`DisplaySettingSlide ${isSettingVisible?"Visible":"Invisible"}`}
            onClick={(e) => { e.stopPropagation(); }}
        >
            <div className={"ProceedingMethodSetting"}>
                <div className={"AttributeName"} >
                    {"넘김방식"}
                </div>
                <div className={"ButtonBox"} >
                    <div 
                        className={`${setting.type === "scrolled" ? "Selected" : ""}`} 
                        onClick={() => setType("scrolled")}
                    >{"스크롤뷰"}</div>
                </div>
            </div>
            <div className={"ThemeSetting"}>
                <div className={"AttributeName"} >
                    {"테마"}
                </div>
                <div className={"ButtonBox"} >
                    {(['light', 'dark'] as displaySettings['theme'][]).map( (themeColor) => <div 
                        className={`${themeColor} ${setting.theme === themeColor ? "Selected" : ""}`} 
                        onClick={() => setTheme(themeColor)}
                        key={themeColor}
                    >{"가"}</div>)}
                </div>
            </div>
            <div className={"FontSizeSetting"}>
                <div className={"AttributeName"} >
                    {"글자크기"}
                </div>
                <div className={"ButtonBox"} >
                    {(["80%", "100%", "120%"] as displaySettings['fontSize'][]).map( (size) => {
                        return <div 
                            className={`${setting.fontSize === size  ? "Selected" : ""}`} 
                            onClick={() => setFontSize(size)}
                            key={size}
                        >{sizeLabel[size]}</div>;
                    })}
                </div>
            </div>
        </div>
        {serviceId && titleId && /* Age Verification Dialog */
        <AgeVerificationDialog
            serviceId={serviceId || ""}
            titleId={titleId || ""}
            open={showAgeVerification}
            onClose={()=>{
                setShowAgeVerification(false);
            }}
            onSuccess={()=>{
                setShowAgeVerification(false);
                logBehavior('age-verification-complete', { serviceId, titleId, });
                fn.goto(`/payment/${serviceId}/${titleId}`);
            }}
        />}
    </div>;
}

export default UIGroup;